import { configure as mobxConfigure } from "mobx"

/* turn off strict mode before we do anything. Otherwise, some value changes may not be applied */
mobxConfigure({
    enforceActions: "never"
})

export const main = () => import("./main")
main()
